import { max } from 'date-fns'

import { InvoiceLineType } from '@features/invoices/enums/invoiceLineType'
import { InvoicePayloadLine } from '@features/invoices/types/invoicePayload/invoicePayloadLine'
import { InvoicePayloadRowLine } from '@features/invoices/types/invoicePayload/invoicePayloadRowLine'
import { InvoiceLine } from '@features/invoices/types/invoices/invoiceLine'

export const getMaxDateOfSaleOrServiceFromLines = (lines: (InvoicePayloadLine | InvoiceLine)[]): Date | null => {
  const rowLineDates = (lines.filter((line) => line.type === InvoiceLineType.Row) as InvoicePayloadRowLine[])
    .map((line) => line.date)
    .filter(Boolean)
    .map((date) => new Date(date))

  return rowLineDates.length > 0 ? max(rowLineDates) : null
}
